export default "__VITE_ASSET__BTy9v4nx__"